import React from "react";
import { PropTypes } from "prop-types";
import { Header, Segment } from "semantic-ui-react";
import JsonSchemaViewer from "./json-schema-viewer";

const DataModelDocs = ({ schema, modelName }) => {
  return (
    <>
      <Header as="h2">Data model documentation</Header>
      <Segment>
        <JsonSchemaViewer schema={schema} name={modelName} />
      </Segment>
    </>
  );
};

DataModelDocs.propTypes = {
  schema: PropTypes.object.isRequired,
  modelName: PropTypes.string.isRequired,
};

export default DataModelDocs;
